import { Fragment, PureComponent } from 'react';
import Head from 'next/head';

import styles from './_error.module.scss';

class Error extends PureComponent {
  static getInitialProps({ res, err }) {
    let statusCode = 404;
    if (res) {
      statusCode = res.statusCode;
    } else if (err) {
      statusCode = err.statusCode;
    }
    return { statusCode };
  }

  render() {
    const { statusCode } = this.props;

    const title =
      statusCode?.toString() === '404' ? 'Page not found' : 'Server error';

    return (
      <Fragment>
        <Head>
          <title>{`John Lewis &amp; Partners | ${title}`}</title>
        </Head>

        <main id="main" className={styles.error} tabIndex="-1">
          <h1 className={styles.error__heading}>Hang on</h1>
          <p className={styles.error__copy}>
            We can&apos;t find the page you&apos;re looking for. Please return
            to our <a href="https://www.johnlewis.com">homepage</a>
          </p>
        </main>
      </Fragment>
    );
  }
}

export default Error;
